import { ComponentType } from 'react';
import { AuthRouteObjectBuilder, Modules } from 'scbk-services';
import { Loading } from 'scbk-ui-web';

const modules = import.meta.glob<{ default: ComponentType<any> }>('../pages/**/*MS.tsx');

const routeBuilder: AuthRouteObjectBuilder = new AuthRouteObjectBuilder(
    modules,
    Modules.DEPOSIT,
    <Loading loading={true} />,
);
const routeObjects = routeBuilder.build();

export { routeObjects };
